import AnimatedBlocks from "common/components/AnimatedIcons/AnimatedBlocks/AnimatedBlocks";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import FileUploader, {UploadOneFile} from "common/components/FileUploader/FileUploader";
import FormElement from "common/components/FormElement/FormElement";
import TagInput from "common/components/TagInput/TagInput";
import Heading from "common/components/Typography/Heading/Heading";
import { retrieveCatalogs } from "modules/bussiness_logic/actions/catalogActions";
import FELInterpreter from "modules/bussiness_logic/components/FELInterpreter/FELInterpreter";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from 'services/BackendApi/BackendApi';
import styles from './NuevoTramiteView.module.scss';
import { formatCurrency } from "common/helpers/DataFormat";
import { Button } from "react-bootstrap";
import FileViewer from "common/components/FileViewer/FileViewer";
import OneFel from "./OneFel/OneFel";
import { FiletypeXml } from "react-bootstrap-icons";
import { Download } from "react-bootstrap-icons";
import { FastForward } from "react-bootstrap-icons";
import { Trash } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import MessageRenderer from "common/components/MessageRenderer/MessageRenderer";
import { SkipBackward } from "react-bootstrap-icons";
import OneSupportDocument from "./OneSupportDocument/OneSupportDocument";
import { CheckCircle } from "react-bootstrap-icons";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import OneRecibo from "./OneRecibo/OneRecibo";

/* TODO> 2023-04-19
    1.- Revisar todas las opciones donde se pueda salir del diálogo y confirmar si está de acuerdo en salirse.
    2.- Revisar lo de las fechas de las que son válidas las facturas para validarlas
    3.- Hacer los ajustes necesarios para que este mismo formulario pueda servir para recibos o Invoices.
    4.- Hacer la validación de los datos en la tranasacción, como que la hoja exista etc y que sea para el proveedor etc.
*/


const formErrorLabels ={
    emails: 'Por favor ingrese al menos una dirección válida para el trámite.',
    enterprise: "Por favor, seleccione una sociedad",
    no_pedido: "Por favor ingrese un número de pedido para proceder con su trámite",
    hoja_entrada: "Por favor ingrese un número de hoja de entrada válido para continuar con su trámite"
}


export default function NuevoTramiteView(props){
    const {tipo} = useParams();
    const navigate = useNavigate();
    const [suggestedEmails, setSuggestedEmails] = useState({loading:true, emails:[]});
    const [oneFEL,setOneFEL] = useState({error:false,verifying: false, data:null});
    const [oneRecibo,setOneRecibo] = useState({moneda:'GTQ',fecha:((new Date()).toISOString().split('T')[0]),serie:'',numero:'',file:null});
    const [oneSupportDoc,setOneSupportDoc] = useState({error:false,verifying: false, data:null});
    const [filePreview, setFilePreview] = useState(null);
    const [txState, setTxState] = useState({loading:false, finalized: false, error:false, error_log:[], success:false});
    const [confirmationDialog, setConfirmationDialog] = useState({
        displayed: false,
        title: '',
        body: '',
        cancelCallback: null,
        confirmCallback: null
    });
    const [formData, setFormData] = useState({
        enterprise:'',
        emails: '',
        no_pedido: '',
        hoja_entrada:[],
        documentos:[],
        documentos_soporte:[]
    });
    const [reciboDataError,setReciboDataError] = useState({
        serie: false,
        numero: false,
        fecha: false
    });
    const [formDataError, setFormDataError] = useState({
        emails: false,
        no_pedido: false,
        hoja_entrada: false,
    });
    const [soporteDocsError, setSoporteDocsError] = useState({
        status:true
    });
    const [wizardState, setWizardState] = useState({step: 0});
    const dispatch = useDispatch();

    async function getEmailList(){

        setSuggestedEmails({...suggestedEmails,loading:true});

        const {data} = await Axios.SuggestedListNotificationAccounts();
 
       
        if (data.error===true){
            //console.log("Suggested ERROR... ",data);
            setSuggestedEmails({...suggestedEmails,loading:false});
            return false;
        }else{
            //console.log("Suggested was... ",data);
            
            if (data.query_result[0].result.length>0){
                if (data.query_result[0].result.error==true){
                    setSuggestedEmails({...suggestedEmails,loading:false});
                    return false;
                }else{
                    let emails = [];
                    data.query_result[0].result.forEach(element => {
                        emails[emails.length] = element.email;
                    });
                    setFormData({...formData,emails: emails});
                    setSuggestedEmails({...suggestedEmails,loading:false});
                    return true;
                }
            }else{
                setSuggestedEmails({...suggestedEmails,loading:false});
            }
            
            //addDocumento(payload);
        }
    }

    useEffect(()=>{
        dispatch(retrieveCatalogs());
        getEmailList();

    },[dispatch]);

    const {catalogs} = useSelector((state)=> { 
        return state;
    });
    function addDocumento(Ob){
        let newFormData = {...formData};
        newFormData.documentos.push(Ob);
        //Acá debo subir el archivo y guardar el ID, podría hacer un render de que se subió y luego se convierte en link
        setFormData(newFormData);
    }
    function handleChangeReciboMonto(evc){
        const newReciboData = {...oneRecibo};
        newReciboData["monto"]=evc;
        setOneRecibo(newReciboData);
    }
    function handleChangeRecibo(evc){
        console.log("One Recibo Data",evc);
        const newReciboData = {...oneRecibo};
        if (typeof(evc.target.value)==="string")
        newReciboData[evc.target.name]=evc.target.value.trim();
        else
        newReciboData[evc.target.name]=evc.target.value;
        setOneRecibo(newReciboData);
        
    }
    function handleChange(evc){
        const newFormData = {...formData};
        let newFormDataErrors = {...formDataError};
        if (typeof(evc.target.value)==="string")
        newFormData[evc.target.name]=evc.target.value.trim();
        else
        newFormData[evc.target.name]=evc.target.value;
    
        setFormData(newFormData);
        newFormDataErrors[evc.target.name]=false;
        setFormDataError(newFormDataErrors);
        
    }
    function handleChangeSupportDtype(evc){
        
        if (parseInt(evc.target.value)!==0){
            let tdoc = catalogs.support_document_types.filter((one)=> one.id===parseInt(evc.target.value));
            if (tdoc.length>0){
                let {code} = tdoc[0];
                let allowedTypes = ".pdf";
                if (code.indexOf("_XLS")>0){
                    allowedTypes = ".xlsx, .xls";
                }
                setOneSupportDoc({...oneSupportDoc, data:{ document_type: parseInt(evc.target.value), fileExtension: allowedTypes }});
            }
        }
        else
        setOneSupportDoc({...oneSupportDoc, data:null});
    }
    async function validarFEL(payload){
        const felData = payload.FELData;
        const {data} = await Axios.ValidarFEL({
            serie: felData.info.autorizacion.serie ,
            numero:felData.info.autorizacion.numero,
            nit_emisor:felData.emisor.nit,
            autorizacion:felData.info.autorizacion.value,
            fecha_emision:felData.info.fecha_emision
        });
 
        if (data.error===true){
            
            setOneFEL({error: true, verifying:false, error_log:data.error_log, data: null});
            return false;
        }else{
            if (data.freeSQL_result.result.length>0){
                if (data.freeSQL_result.result[0].error==true){
                    setOneFEL({error: true, verifying:false, error_log:(Array.isArray(data.freeSQL_result.result[0].error_log))?data.freeSQL_result.result[0].error_log:[data.freeSQL_result.result[0].error_log], data: payload});
                }else{
                    setOneFEL({error: false, verifying:false, error_log:[], data: payload});
                }
            }else{
                setOneFEL({error: false, verifying:false, error_log:[], data: payload});
            }
            
            //addDocumento(payload);
        }
    }
    function validateFEL(payload){

        if (payload.FELData.error){
            setOneFEL({error: true, verifying: false, error_log:[payload.FELData.message], data: null});
        }else{
            if (formData.documentos.length==0){
                const result = catalogs.enterprises.filter(oneE => oneE.tax_payer_id === payload.FELData.receptor.nit);
                    
                    if (result.length==0){ 
                        setOneFEL({data: null, error: true, verifying: false, error_log:["El NIT al que emite el documento no coincide con ninguna empresa del Grupo. Por favor revise los datos de emisión."]});
                    }else{
                        setOneFEL({...oneFEL, verifying: true});
                        handleChange({
                            
                                target:{
                                    name: 'enterprise',
                                    value: result[0].erp_code1
                                }
                         
                        })
                       validarFEL(payload);
                            
                    
                        
                    }
               
            }
            else
                if (formData.documentos.every(
                    (oneFEL) =>  (!(oneFEL.FELData.info.autorizacion.value===payload.FELData.info.autorizacion.value)) )
                ){
                    //no se haya subido la fact 2 veces
                    const result = catalogs.enterprises.filter(oneE => oneE.tax_payer_id === payload.FELData.receptor.nit);
                    
                    if (result.length==0){ 
                        setOneFEL({error: true, error_log:["El NIT al que emite el documento no coincide con ninguna empresa del Grupo. Por favor revise los datos de emisión."]});
                    }else{
                        if (formData.enterprise == result[0].erp_code1){
                            handleChange({
                            
                                    target:{
                                        name: 'enterprise',
                                        value: result[0].erp_code1
                                    }
                            })
                            validarFEL(payload);
                        }else{
                            setOneFEL({data: null, error: true, error_log:["Todas los documentos deben de haber sido emitidos a la misma sociedad, La factura con Autorización "+payload.FELData.info.autorizacion.value+" fue emitida a "+result[0].name+" NIT:"+result[0].tax_payer_id]});
                        }
                    }
                }else{
                    setOneFEL({data: null, error: true, error_log:["Documento Duplicado, La factura con Autorización "+payload.FELData.info.autorizacion.value+" ya ha sido subida"]});
                }
        }

        // aca debo validar que:
        // 0.- Sea un FEL Valido
        // 1.- el NIT de la empresa a la que se factura sea uno de los que estan en el listado
    }
    function cancelarDTE(){

        setOneFEL({error:false,verifying: false, data:null});
    }
    function cancelarRecibo(){

        setOneRecibo({moneda:'GTQ',fecha:((new Date()).toISOString().split('T')[0]),serie:'',numero:'',file:null});
    }
    function DTEPDFCallback(type,data){
        
        setOneFEL({error: false, verifying:false, error_log:[], data: {...oneFEL.data, pdf: data}});
    }
    function SoporteDocumentCallback(type,data){
        
        switch (type){
            case "UPLOAD_SUCCESSFULL":{
                setOneSupportDoc({error: false, verifying:false, error_log:[], finalized: true, data: {... oneSupportDoc.data, file: data}});
                let newFormData = {...formData};
                newFormData.documentos_soporte.push({... oneSupportDoc.data, file: data});
                setOneSupportDoc({error:false,verifying: false, data:null});
                if (nextStepAllowed()){
                    
                    setSoporteDocsError({status:false});
                }else{
                    setSoporteDocsError({status:true});
                }
                setTimeout(()=>{
                    setOneSupportDoc({error:false,verifying: false, data:null});
                    
                },2000);
            }break;
        }
    }
    function ReciboDocumentCallback(type,data){
        
        switch (type){
            case "UPLOAD_SUCCESSFULL":{
                setOneRecibo({
                    ...oneRecibo,
                    file: data
                })
                /*let newFormData = {...formData};
                newFormData.documentos.push({file: data});
                setFormData(newFormData);*/
            }break;
        }
    }
    function switchUploaderVisor(){
        
        if (!oneFEL.finalizing)
            if (oneFEL.data.pdf){
                
                return <FileViewer file={oneFEL.data.pdf.id} grantKey={oneFEL.data.pdf.grant} />;
            }else{
                return <FileUploader dropLabel={<span>Por favor arrastre y suelte su archivo <br /> o haga click acá y suba el PDF del DTE acá</span>} acceptOnly=".pdf" callBack={DTEPDFCallback} ></FileUploader>;
                
            }      
        else {
            return <div><AnimatedBlocks stroke="#212529" fill="#212529" /> Adjuntando documentos al trámite ...</div>;
        }
    
    }
    function validarOneRecibo(){
        let result=true;
        let newReciboError = {...reciboDataError};
        console.log(oneRecibo.monto);
        newReciboError.monto = !(oneRecibo.monto>0.00); 
        newReciboError.serie = (oneRecibo.serie.trim()=="");
        newReciboError.numero = (oneRecibo.numero.trim()=="");
        result = !newReciboError.monto && !newReciboError.serie && !newReciboError.numero;
        setReciboDataError(newReciboError);
        return result;
    }
    function adjuntarDocumentoRecibo(){
        if (validarOneRecibo()){
            addDocumento({...oneRecibo});
            setOneRecibo({moneda:'GTQ',fecha:((new Date()).toISOString().split('T')[0]),serie:'',numero:'',file:null});
        }
    }
    function adjuntarDocumento(){
        setOneFEL({...oneFEL, finalizing: true});
        UploadOneFile(oneFEL.data.FELFile, (progress)=> console.log("Progress XML",progress),(resultType,data)=>{
            console.log("on Calback XML", resultType,data);
            addDocumento({...oneFEL.data, xml: data });
            setOneFEL({error:false,verifying: false, data:null});
        });

    }
    function renderPreview(){
        if (filePreview!==null){
            return <Modal show={true} onHide={(event, reason)=>{setFilePreview(null)}}  dialogClassName={styles.uploadpdfmodal}>
                <Modal.Header closeButton>
                    <h2>Documento</h2>
                </Modal.Header>
                <Modal.Body className={styles.previewmodalbody}>
                    <FileViewer variant={(filePreview.type=="pdf")?"view":"download"} file={filePreview.id} openingLabel={(filePreview.type=="pdf")?"Accediendo al archivo...":<Button onClick={(event)=>{setFilePreview(null)}} className={styles.downloadxmlbutton}>Descargar XML <FiletypeXml /> <Download /></Button>}  />
                </Modal.Body>
            </Modal>;
        }
    }
    function reciboButtonCallback(action,data){
        if (action==="delete"){
            setConfirmationDialog(
                {
                    displayed:true,
                    title: 'Confirmar descarte',
                    body:"¿Está seguro que desea descartar este documento?",
                    confirmCallback: (()=>{
                        let newFormData = {...formData};
                        newFormData.documentos.splice(data.pos,1);
                        setFormData(newFormData);
                    })
                }
            )
           
        }else{
            //console.log(data);
            switch(action){
                case "PDF": setFilePreview({ id: data.id, type:'pdf' }); break;
            }
            
        }
    }
    function felButtonCallback(action,data){
        if (action==="delete"){
            setConfirmationDialog(
                {
                    displayed:true,
                    title: 'Confirmar descarte',
                    body:"¿Está seguro que desea descartar este documento?",
                    confirmCallback: (()=>{
                        let newFormData = {...formData};
                        newFormData.documentos.splice(data.pos,1);
                        setFormData(newFormData);
                    })
                }
            )
           
        }else{
            switch(action){
                case "PDF": setFilePreview({ id: data.id, type:'pdf' }); break;
                case "XML": setFilePreview({ id: data.id, type:'xml' }); /*TODO*/ break;
            }
            
        }
    }
    function deleteSupportDocumentCallback(position){
        setConfirmationDialog(
            {
                displayed:true,
                title: 'Confirmar descarte',
                body:"¿Está seguro que desea descartar este documento?",
                confirmCallback: (()=>{
                    let newFormData = {...formData};
                    newFormData.documentos_soporte.splice(position,1);
                    if (nextStepAllowed()){
                        setSoporteDocsError({status:false});
                    }else{
                        setSoporteDocsError({status:true});
                    }
                })
            }
        )
            
       
    }
    function renderConfirmation(){
        if (confirmationDialog.displayed===true){
            return <Modal show={confirmationDialog.displayed} onHide={(event, reason)=>{
                setConfirmationDialog({
                    displayed: false,
                    title: '',
                    body: '',
                    cancelCallback: null,
                    confirmCallback: null
                });
            }}  backdrop="static" keyboard={false}>
            <Modal.Header closeButton={false}>
                {confirmationDialog.title}
            </Modal.Header>
            <Modal.Body>
                <Container>
                        <div className={styles.warncont}>
                        <ExclamationTriangleFill className={styles.bigwarning} />

                        <i className="fa-solid fa-triangle-exclamation fa-fade"></i>
                        <div>
                            {confirmationDialog.body}
                        </div>
                        </div>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={(evc)=>{
                    setConfirmationDialog({
                        displayed: false,
                        title: '',
                        body: '',
                        cancelCallback: null,
                        confirmCallback: null
                    });
                    if (typeof(confirmationDialog.cancelCallback)=="function") confirmationDialog.cancelCallback();
                }}>Cancelar</Button>
                <Button variant="danger" onClick={(evc)=>{
                    setConfirmationDialog({
                        displayed: false,
                        title: '',
                        body: '',
                        cancelCallback: null,
                        confirmCallback: null
                    });
                    if (typeof(confirmationDialog.confirmCallback)=="function") confirmationDialog.confirmCallback();
                }}>Confirmar</Button>
            </Modal.Footer>
        </Modal>;
        }
    }
    function renderOneReciboFormModal(){
        if (oneRecibo.file!==null){
            //indica que ya subio el file
            return <Modal show={true} onHide={(event, reason)=>{}}  dialogClassName={styles.reciboformmodal} backdrop="static" keyboard={false}>
                <Modal.Header closeButton={false}>
                    <h1>Siguiente paso: Ingrese los datos de su documento</h1>
                </Modal.Header>
                <Modal.Body className={styles.modalcontentrecibo}>
                    <Container className={styles.x100percent}>
                            <Row className={styles.x100percent}>
                                <Col>
                                    <Heading variant="h3">Datos del documento</Heading>
                                    <Row>
                                        <Col className={styles.labeldatafactura}>
                                        <FormElement type="text" label="Serie" id="serie" name="serie" value={oneRecibo.serie} fieldLength={4}  onChange={handleChangeRecibo} error={reciboDataError.serie}
                                            errorMessage="Debe ingresar la serie"
                                            
                                        ></FormElement>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura}>
                                        <FormElement type="number" label="Número" id="numero" name="numero" value={oneRecibo.numero} fieldLength={4}  onChange={handleChangeRecibo} error={reciboDataError.numero}
                                            errorMessage="Debe ingresar el número"
                                            events={{step:1, min:0}}
                                        ></FormElement>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura}>
                                        <FormElement type="date" label="Fecha" id="fecha" name="fecha" value={oneRecibo.fecha} fieldLength={6}  onChange={handleChangeRecibo} error={reciboDataError.fecha}
                                            errorMessage="Debe ingresar la fecha"
                                            
                                        ></FormElement>
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col className={styles.labeldatafactura}>
                                        
                                        <FormElement label="Moneda" id="moneda" name="moneda" value={oneRecibo.moneda} type="dropdown" onChange={handleChangeRecibo}  error={reciboDataError.moneda} fieldLength={6} errorMessage="Debe ingresar la moneda">
                                        {
                                            catalogs.currencies.map((curr,index)=>
                                            <option value={curr.code} key={index}>{curr.symbol} - {curr.name}</option>
                                            )
                                        }
                                    </FormElement>
                                        </Col>
                                    </Row>
                                    <Row>
                                    <Col className={styles.labeldatafactura}>

                                        <FormElement label="Monto" type='currency'  id="monto" name="monto" currency={oneRecibo.moneda} value={oneRecibo.monto} prefix=''   onChange={handleChangeReciboMonto}  fieldLength={3} error={reciboDataError.monto}
                                                errorMessage="Debe ingresar un monto válido"
                                            />
                                        
                                    </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <FileViewer variant={"view"} file={oneRecibo.file.id} openingLabel={"Accediendo al archivo..."} />
                                </Col>
                            </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelarRecibo}>Descartar</Button>
                    <Button variant="primary" onClick={adjuntarDocumentoRecibo}>Adjuntar documentos al trámite de pago</Button>
                </Modal.Footer>
            </Modal>;
        }
        return "";
    }
    function renderModal(){
        if (oneFEL.error===true){
            return <Modal show={oneFEL.error} onHide={(event, reason)=>{setOneFEL({error:false,data:null})}}>
                <Modal.Header closeButton>
                    Hubo un problema con la Factura
                </Modal.Header>
                <Modal.Body>
                    <Container>
                            <ErrorMark />
                            <div>
                                Los errores encontrados fueron:
                                <ul>
                                    {oneFEL.error_log.map((oneError,idx)=> <li key={idx}>{oneError}</li>)}
                                </ul>
                                Por favor ingrese una nueva factura.
                            </div>
                    </Container>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>;
        }else{
            if (oneFEL.data!==null)
            return <Modal show={true} onHide={(event, reason)=>{setOneFEL({error:false,data:null})}}  dialogClassName={styles.uploadpdfmodal} backdrop="static" keyboard={false}>
                <Modal.Header closeButton={false}>
                    <h1>Siguiente paso: Suba el PDF del DTE</h1>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                            <Row>
                                <Col>
                                    <Heading variant="h3">Datos de la DTE</Heading>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>NIT del Emisor:</Col>
                                        <Col>{oneFEL.data.FELData.emisor.nit}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Emitido por:</Col>
                                        <Col>{oneFEL.data.FELData.emisor.nombre}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>NIT del Receptor:</Col>
                                        <Col>{oneFEL.data.FELData.receptor.nit}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Receptor:</Col>
                                        <Col>{oneFEL.data.FELData.receptor.nombre}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Serie:</Col>
                                        <Col>{oneFEL.data.FELData.info.autorizacion.serie}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Número:</Col>
                                        <Col>{oneFEL.data.FELData.info.autorizacion.numero}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Autorización:</Col>
                                        <Col>{oneFEL.data.FELData.info.autorizacion.value}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Emitida el:</Col>
                                        <Col>{oneFEL.data.FELData.info.fecha_emision}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Autorizada el:</Col>
                                        <Col>{oneFEL.data.FELData.info.fecha_emision}</Col>
                                    </Row>
 
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Tipo de DTE:</Col>
                                        <Col>{oneFEL.data.FELData.info.tipo}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Moneda:</Col>
                                        <Col>{oneFEL.data.FELData.info.moneda}</Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={4}>Monto:</Col>
                                        <Col>{formatCurrency(oneFEL.data.FELData.info.moneda,oneFEL.data.FELData.info.monto)}</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    {switchUploaderVisor()}
                                </Col>
                            </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelarDTE}>Descartar</Button>
                    <Button variant="primary" disabled={(undefined===oneFEL.data.pdf)}onClick={adjuntarDocumento}>Adjuntar documentos al trámite de pago</Button>
                </Modal.Footer>
            </Modal>;

        }

        return "";

    }

    function descartarTramite(evc){
        setConfirmationDialog(
            {
                displayed:true,
                title: 'Confirmar descarte',
                body:"¿Está seguro que desea descartar el trámite completo?",
                confirmCallback: (()=>{
                    navigate('/',true);
                })
            }
        )
        
    }
    function validarFormulario(){
        let newFormDataErrors = {...formDataError};
        let response = true;
        newFormDataErrors.emails = (!formData.emails.length>0);
        response = response && !newFormDataErrors.emails;

        newFormDataErrors.hoja_entrada = (
            (formData.hoja_entrada.length==0)
            /*||
            (!
                parseInt(formData.hoja_entrada.trim())>0
            )*/
        );
        response = response && !newFormDataErrors.hoja_entrada;
        newFormDataErrors.no_pedido = (
            (formData.no_pedido.trim()==="")
            ||
            (
                isNaN(parseInt(formData.no_pedido.trim()))
            )
        );
        response = response && !newFormDataErrors.no_pedido;

        newFormDataErrors.enterprise = (
            (formData.enterprise.trim()==="")
        );
        response = response && !newFormDataErrors.enterprise;
        console.log("Error en enterprise",newFormDataErrors);
        setFormDataError(newFormDataErrors);
        if (response===true) notifyFetch();
        return response;
    }
    async function notifyFetch(){
        const {data2} = await Axios.AdvanceFetch({"enterprise":formData.enterprise},{urlParams:{ type: "no_pedido",value:formData.no_pedido}});
        
        const {data1} = await Axios.AdvanceFetch({"enterprise":formData.enterprise},{urlParams:{ type: "hoja_entrada",value:formData.hoja_entrada}});
        //console.log('hoja_entrada',data1);
        
        //console.log('no_pedido',data2);
    }
    function prevStep(){
        setWizardState({step: wizardState.step-1});
        if (nextStepAllowed(wizardState.step-1)){
            setSoporteDocsError({status:false});
        }else{
            setSoporteDocsError({status:true});
        }
    }
    function nextStep(){
        if (validarFormulario()===true){

            setWizardState({step: wizardState.step+1});
            if (nextStepAllowed(wizardState.step+1)){
            
                setSoporteDocsError({status:false});
            }else{
            
                setSoporteDocsError({status:true});
            }
        }
    }
    async function registerTramite(){
        if (txState.loading==false && txState.finalized==false){
            setTxState({...txState,loading:true,finalized:false});
            if (formData.enterprise.trim()==""){

            }
            const {data} = (tipo=="factura")? await Axios.NewTramite(formData): await Axios.NewTramiteRecibo(formData);
            //console.log(data);
            if ((data.error===true)){
                setTxState({...txState,error:true,finalized:true,loading:false,error_log:(Array.isArray(data.error_log))?data.error_log:[data.error_log]});
                setWizardState({step: 99});
            }else
            if ((data.freeSQL_result.result.length>0) && data.freeSQL_result.result[0].error===1){
                setTxState({...txState,error:true,finalized:true,loading:false,error_log:(Array.isArray(data.freeSQL_result.result[0].error_log))?data.error_log:[data.freeSQL_result.result[0].error_log]});
                setWizardState({step: 99});
            }
            else 
            {
                
                setTxState({...txState,error:false,finalized:true,loading:false,error_log:[]});
                setWizardState({step: 4});
            }
        }
    }
    function getNextStepErrorMessage(){
        
        let message = "Para continuar debe ingresar: ";
        if (soporteDocsError.status==false) return ""; 
        switch (wizardState.step){

            case 1:{
                
                let pedidoItems = formData.documentos_soporte.filter((elemento)=>{
                    return elemento.type==8;
                });
                if (pedidoItems.length==0) {
                    
                        message+="(1) un pedido";
                    
                    
                }
                let hojaEntradaItems = formData.documentos_soporte.filter((elemento)=>{
                    return elemento.type==8;
                });
                if (hojaEntradaItems.length < formData.hoja_entrada.length) {
                    
                        
                            
                            //message+= ",("+(formData.hoja_entrada.length-hojaEntradaItems.length).toString()+") hoja(s) de entrada.";
                            message+= ",con su(s) respectiva(s) hoja(s) de entrada.";
                            
                        
                }

                return <span className={styles.nexstepError}>{message}</span>;
                

            }break;
            default:{
                return message;
            }break;
        }
    }
    function nextStepAllowed(toCheck){
        if (undefined===toCheck) toCheck = wizardState.step;
        
        switch (toCheck){

            case 1:{
                let result = true;
                let pedidoItems = formData.documentos_soporte.filter((elemento)=>{
                    
                    return elemento.document_type==8;
                });
                if (pedidoItems.length==0) result = false;
                let hojaEntradaItems = formData.documentos_soporte.filter((elemento)=>{
                    
                    return elemento.document_type==9;
                });
                if (hojaEntradaItems.length < 1 /*formData.hoja_entrada.length*/) result = false;
                return result;
                

            }break;
            default:{
                return false;
            }break;
        }
    }
    function finalizeTramite(){
        nextStep();
        registerTramite();
    }
    if (suggestedEmails.loading== true){
        return <div><AnimatedBlocks /> Cargando ... </div>;
    }
    if (["factura","recibo"].includes(tipo))
        switch (wizardState.step){
            case 0:
                return <div className={styles.wrapper}>
                            {renderConfirmation()}
                            {renderModal()}
                            {renderPreview()}
                            {(tipo=="recibo")?renderOneReciboFormModal():''}

                    <Heading variant="h3">Datos y documentos de su trámite de pago de {(tipo=="factura")? "Factura Electrónica": "Recibos o Invoices"} <span className={styles.stepspan}>Paso 1 de 3</span></Heading>
                    <Form>
                                    <FormElement type="taginput" label="E-mail(s) para recibir notificaciones" id="emails" name="emails" value={formData.emails} fieldLength={8} onChange={handleChange} error={formDataError.emails}
                                        errorMessage={formErrorLabels.emails}
                                    events={{separators:[188], validator:(value)=>{
                                        return String(value).toLowerCase()
                                                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                                    }}}><small>Puede ingresar varias direcciones separadas por comas.</small></FormElement>
                                    <FormElement type="number" label="No. Pedido (Órden de compra)" id="no_pedido" name="no_pedido" value={formData.no_pedido} fieldLength={4}  onChange={handleChange} error={formDataError.no_pedido}
                                        errorMessage={formErrorLabels.no_pedido}
                                        events={{step:1, min:0}}
                                    ></FormElement>

                                    {/*<FormElement type="number" label="No. de Hoja de Entrada" id="hoja_entrada" name="hoja_entrada" value={formData.hoja_entrada} fieldLength={4}  onChange={handleChange} error={formDataError.hoja_entrada}
                                        errorMessage={formErrorLabels.hoja_entrada}
                                    ></FormElement>*/}
                                    <FormElement type="taginput" label="No. de Hoja de Entrada" id="hoja_entrada" name="hoja_entrada" value={formData.hoja_entrada} fieldLength={4}  onChange={handleChange} error={formDataError.hoja_entrada}
                                        errorMessage={formErrorLabels.hoja_entrada}

                                         events={{separators:[188], validator:(value)=>{
                                        return String(value).toLowerCase()
                                                    .match(/^([0-9]+)$/);
                                        }}}


                                    >
                                        <small>Puede ingresar varias separadas por comas.</small>

                                    </FormElement>
                                    <FormElement label={(tipo=="factura")?"Sociedad a la que factura":"Sociedad a la que emite el documento"} id="enterprise" name="enterprise" value={formData.enterprise} type="dropdown" onChange={handleChange}error={formDataError.enterprise} fieldLength={6} errorMessage={formErrorLabels.enterprise}>
                                        <option value="">-- Por favor seleccione una sociedad ---</option>
                                        {
                                            catalogs.enterprises.map((enterprise,index)=>
                                            <option value={enterprise.erp_code1} key={index}>NIT: {enterprise.tax_payer_id} - {enterprise.name} </option>
                                            )
                                        }
                                    </FormElement>
                                    {
                                        formData.documentos.map((oneDoc,idx)=> <div key={idx}>
                                            {   (tipo=="factura")?
                                                <OneFel pos={idx} data={oneDoc} onButtonCallBack={felButtonCallback} />:
                                                <OneRecibo pos={idx} data={oneDoc} onButtonCallBack={reciboButtonCallback} />
                                            }
                                        </div>)
                                    }
                                    
                                    {
                                        (tipo=="factura")?
                                    <FormElement label={formData.documentos.length==0? "Subir FEL XML":"Subir FEL en XML adicional"} type="void" error={formDataError.felXML} fieldLength={10}>
                                        
                                        {
                                            (oneFEL.verifying==true)? <div className={styles.verifyingbox}><AnimatedBlocks stroke="#212529" fill="#212529" /> Verificando el documento ...</div>: <FELInterpreter onSuccessData={(data)=>validateFEL(data)} />
                                        }
                                        
                                        
                                    </FormElement>:
                                    <FormElement label={formData.documentos.length==0? "Subir RECIBO o Invoice":"Subir Recibo o Invoice adicional"} type="void" error={formDataError.felXML} fieldLength={10}>
                                            
                                        {
                                           <FileUploader dropLabel={<span>Por favor arrastre y suelte su recibo o invoice en formato PDF<br /> o haga click acá y suba el archivo</span>} acceptOnly={".pdf"} callBack={ReciboDocumentCallback} ></FileUploader>
                                        }
                                        
                                        
                                    </FormElement>
                                    }
                    </Form>
                    {
                                        (formData.documentos.length>0)? <div className={styles.nexttoolbar}><Button variant="danger" className={styles.discardbutton} onClick={descartarTramite}><Trash /> Descartar trámite </Button><Button variant="primary" className={styles.nextbutton} onClick={nextStep}>Siguiente paso <FastForward /></Button></div>:''
                    }
                </div>; break;

            case 1:{
                return <div className={styles.scrollmessageplus}>
                    {renderConfirmation()}
                        <Heading variant="h2">Ingreso documentos de soporte <span className={styles.stepspan}>Paso 2 de 3</span></Heading>
                        <MessageRenderer keyCode="PROV_MSG001" />
                        <div>
                            {
                                formData.documentos_soporte.map((dsoporte,idx)=> <OneSupportDocument data={dsoporte} key={idx} pos={idx} deleteCallback={deleteSupportDocumentCallback} />)
                            }
                        </div>
                        <div className={styles.newsupportdoc}>
                            <Heading variant="h5">Adjuntar documento</Heading>
                            <Form>

                                    <FormElement label="Tipo de documento" id="supportdoctype" name="supportdoctype" value={(oneSupportDoc.data===null)?0:oneSupportDoc.data.supportdoctype}  type="dropdown" fieldLength={6} onChange={handleChangeSupportDtype}>
                                    <option value={0} key={0}>-- seleccione un tipo --</option>
                                        {
                                            catalogs.support_document_types.map((dt,index)=>
                                            <option value={dt.id} key={index+1}>{dt.code} - {dt.name} </option>
                                            )
                                        }
                                    </FormElement>
                                   
                            {
                                (oneSupportDoc.data!==null)? <FileUploader dropLabel={<span>Por favor arrastre y suelte su archivo <br /> o haga click acá y suba el {(oneSupportDoc.data.fileExtension==".pdf")?"PDF":"ARCHIVO DE EXCEL"} de su documento de soporte acá</span>} acceptOnly={oneSupportDoc.data.fileExtension} callBack={SoporteDocumentCallback} ></FileUploader>
                                : "Seleccione primero el tipo de documento..."
                            }
                            </Form>
                        </div>

                        <div className={styles.nexttoolbar}>
                            <Button variant="secondary" onClick={prevStep} className={styles.prevbutton}><SkipBackward /> Anterior</Button>
                            <Button variant="danger" className={styles.discardbutton} onClick={descartarTramite}><Trash /> Descartar trámite </Button>
                            {
                                        
                                        (soporteDocsError.status==false)? <Button variant="primary" className={styles.nextbutton} onClick={nextStep}>Siguiente paso <FastForward /></Button>:getNextStepErrorMessage()
                            }
                        </div>
                </div>;
            }break;
            case 2:{
                return <div className={styles.scrollmessage}>
                        {renderConfirmation()}
                        <Heading variant="h2">Términos y condiciones <span className={styles.stepspan}>Paso 3 de 3</span></Heading>
                        {
                            wizardState.step==2?<div><MessageRenderer keyCode={"PROV_MSG00"+wizardState.step.toString()} /></div>:"..."
                        }
                        <div className={styles.nexttoolbar}>
                            <Button variant="secondary" onClick={prevStep}  className={styles.prevbutton}><SkipBackward /> Anterior</Button>
                            <Button variant="danger" className={styles.discardbutton} onClick={descartarTramite}><Trash /> Descartar trámite </Button>
                            {
                                        
                                        (formData.documentos_soporte.length>0)? <Button variant="primary" className={styles.nextbutton} onClick={finalizeTramite}>Estoy de acuerdo, proceder <CheckCircle /></Button>:''
                            }
                        </div>
                </div>;
            }break;
            case 3:{
                    return <div className={styles.scrollmessage}>

                        <Heading variant="h2">Registrando trámite...</Heading>
                        <AnimatedBlocks />
                        
                    </div>;
            }break;
            case 4:{
                    return <div className={styles.scrollmessage}>
                    <Heading variant="h2">Éxito</Heading>
                    <CheckMarkSuccess></CheckMarkSuccess>
                    Su trámite ha sido registrado con éxito.<br /> Se le notificará del progreso del mismo a los correos ingresados.
                        <div className={styles.nexttoolbar}>
                            <Button variant="primary" onClick={()=> navigate("/",true)}>Ir al inicio</Button>
                        </div>
                </div>;
            }break;
            case 99:{
                return <div className={styles.scrollmessage}>
                    <Heading variant="h2">Error</Heading>
                    <ErrorMark></ErrorMark>
                    Su trámite ha presentado los siguientes problemas:<br />
                    <ul>
                        {
                            txState.error_log.map((oneE,idx)=><li key={idx}>{oneE}</li>)
                        }
                    </ul>
                        <div className={styles.nexttoolbar}>
                            <Button variant="secondary" onClick={()=> {setWizardState({step:0});
                                setTxState({...txState,error:false,finalized:false,loading:false,error_log:[]});
                            }}  className={styles.prevbutton}><SkipBackward />Revisar</Button>
                        </div>
                </div>;
            }break;
        }
        else
    return <div>Error.</div>;
}